/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { colors } from "./colors";
import { effects } from "./effects";
import { StyledText } from "../assets/typography/typography";

const iconOuterWrapper = css`
  display: flex;
  box-shadow: ${effects.buttonPrimary};
  background: ${colors.white};
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
`;

const iconInnerWrapper = css`
  display: flex;
  background: ${colors.buttonPrimaryWhite};
  border-radius: 2px;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  border: 1px solid ${colors.greyBorder};
`;

const textWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

type Props = {
  icon: React.ReactNode;
  header: string;
  subHeader: string;
};

export const PlaceholderBody = ({ icon, header, subHeader }: Props) => {
  return (
    <>
      <div css={iconOuterWrapper}>
        <div css={iconInnerWrapper}>
          <StyledText
            color={colors.textPrimary}
            className="bodyTextSemibold mb-0"
          >
            {icon}
          </StyledText>
        </div>
      </div>
      <div css={textWrapper}>
        <StyledText
          className="bodyHeaderOneSemi mb-0"
          color={colors.textPrimary}
        >
          {header}
        </StyledText>
        <StyledText
          className="bodyTextRegular mb-0"
          color={colors.textSecondary}
        >
          {subHeader}
        </StyledText>
      </div>
    </>
  );
};
